import React, { useEffect } from 'react';
import { navigate, useLocation } from '@reach/router';

import { RouteComponentProps } from '@reach/router';
import { ICollectionData, IExemplarData, ILessonData, shortUrlAPI } from '../../API/shorturl';
import { FlexBehavior, FlexJustify, Spinner } from 'react-magma-dom';
import { StyledCenteredSpinnerWrapper } from '../../components/Styled/StyledWrappers';
import { COLORS, NOT_FOUND } from '../../constants';

interface AxiosErrorWithStatus extends Error {
  status: number;
}

export const ShortUrl: React.FC<RouteComponentProps> = (): JSX.Element => {
  const { hash } = useLocation();

  const pathFromShortUrl = (data: ICollectionData | IExemplarData | ILessonData): string => {
    switch (data.type) {
      case 'Collection':
        return `/exemplars/${data.stage}`;
      case 'Exemplar':
        return `/exemplars/${data.stage}/exemplar/${data.id}/default/${data.page}`;
      case 'Lesson':
        return `/lessons/collection/${data.collectionId}/exemplarsRelated/${data.exemplarsRelated}/textType/${data.textType}/lessons/${data.id}?page=${data.pageId}`;
    }
  };

  useEffect(() => {
    (async () => {
      try {
        const code = hash.slice(1); // Remove starting # from hash
        const { data } = await shortUrlAPI.getShortUrl(code);

        navigate(pathFromShortUrl(data.data), { replace: true });
      } catch (error) {
        const typedError = error as AxiosErrorWithStatus; // Explicitly type the error

        if (typedError.status === 403) {
          return navigate(`/${NOT_FOUND}`);
        }
      }
    })();
  }, []);

  return (
    <StyledCenteredSpinnerWrapper behavior={FlexBehavior.container} justify={FlexJustify.center}>
      <Spinner color={COLORS.seaBlue} size={50} />
    </StyledCenteredSpinnerWrapper>
  );
};
